import React from 'react';
import _ from 'lodash';
import translator from 'translate-react';

let __ = translator.get;

/**
 * Einen Wert als Zahl parsen und diese zurück geben. Alle anderen ungültigen Eingaben geben 0 zurück.
 */
var parseIntOrZero = function(value) {
    var result = value;
    value = parseInt(value, 10);
    if ( value > 0 ) {
        result = value;
    } else {
        result = 0;
    }
    return result;
}


/**
 * Zusammenfassung der Personen erzeugen. Gibt ein Objekt mit folgenden Keys zurück:
 * 
 * - rooms: Anzahl der ausgewählten Unterkünfte (Räume)
 * - adults: Anzahl der ausgewählten Erwachsenen insgesamt
 * - children: Anzahl der ausgewählten Kinder insgesamt (ohne Prüfung auf Gültigkeit)
 * - kids_ages: Liste der ausgewählten Kinder-Alter (geprüft)
 * - valid_children: Anzahl der ausgewählten Kinder insgesamt (mit ausgewähltem Alter)
 * - missing_kids_age: Fehlen Altersangaben? (bool)
 */
function getPeople(state) {

    let rooms = parseIntOrZero(state["rooms"]);
    let adults = 0;
    let children = 0;
    let children_ages = [];
    let valid_children = 0;
    let missing_kids_age = false;

    for (let i = 1; i <= rooms; i++) {
        let prefix = "rooms." + i + ".";
        let room_kidscount = parseIntOrZero(state[prefix + "children"]);

        adults += parseIntOrZero(state[prefix + "adults"]);
        children += room_kidscount;

        for ( let j = 1; j <= 5; ++j ) {
            if ( room_kidscount >= j ) {
                let age = parseIntOrZero(state[prefix + "child" + j]);
                if ( age > 0 ) {
                    valid_children++;
                    children_ages.push(age);

                } else {
                    missing_kids_age = true;
                }
            }
        }
    }

    children_ages.sort(function(a, b) {return a - b});

    return {
        rooms: rooms,
        adults: adults,
        children: children,
        children_ages: children_ages,
        valid_children: valid_children,
        missing_kids_age: missing_kids_age,
    };
}

/**
 * Gibt einen String zurück, der die Personen in Textform beschreibt
 */
export function getPeopleString(state, format="default") {
    let people = getPeople(state);
    let text = "";
    let roomTitleMap = {
        "any": "Zimmer / Fewo",
        "room": "Zimmer",
        "single": "Einzelzimmer",
        "double": "Doppelzimmer",
        "flat": "Ferienwohnung",
        "house": "Ferienhaus",
        "campsite": "Stellplatz"
    };
    let short   = format === "short" || format === "shorter";
    let shorter = format === "shorter";

    if ( people.rooms === 0 ) {
        return __("Beliebige Personenzahl");
    }

    if ( people.rooms > 1 && !shorter ) {
        text += people.rooms + " Unterkünfte, "; // neutral wg. Zimmer/Fewo/Bett
    }

    if ( shorter ) {
        let num_people = people.adults + people.valid_children;
        text += translator.plural("people", num_people);
    } else {
        let adultText = translator.plural("adult", people.adults);
        if ( people.valid_children ) {
            text += (people.adults > 0) ? adultText + ", " : " keine Erwachsene, ";
            text += translator.plural("child", people.valid_children);
        } else {
            text += adultText;
        }
    }

    if ( people.rooms === 1 && !short ) {
        let roomTypeTitle = roomTitleMap[state["rooms.1.type"]];
        text += " in " + roomTypeTitle;
    }

    return text;
}


function PeopleDisplay(props) {
    let { state, format, people } = props;
    var text = getPeopleString(people, format);

    return <span>{text}</span>;
}


import { connect } from 'react-redux';

const mapStateToProps = (state) => ({
    people: state.people,    
})

export default connect(mapStateToProps)(PeopleDisplay);




/** WEBPACK FOOTER **
 ** ../ibe/components/PeopleDisplay.js
 **/